module.exports = __webpack_public_path__ + "img/ViewSidebarOutlined.8f59cde0.svg";